import React from 'react';
import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { TextBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const RecipientNameField: React.FC = () => {
    const wireRecipientName = useBrokerDetailsStore((s) => s.wireRecipientName);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const changed = useBrokerFieldFieldChanged(FormField.WireRecipientName);
    return (
        <>
            <TextBox
                id='wireRecipientName'
                value={wireRecipientName}
                onChange={(v) => updateFields({ wireRecipientName: v })}
                label='Recipient Name'
                width={'100%'}
                helperText='The name on the bank account.'
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon='asterisk'
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
